import { FiltersState } from "./interests-sidebar/state";

export const storeFilterState = (interestListId: string, state: FiltersState): void => {
  const storedFiltersJson = localStorage.getItem("filters-state") || "{}";
  const filters = JSON.parse(storedFiltersJson);

  filters[interestListId] = state;

  localStorage.setItem(
    "filters-state",
    JSON.stringify(filters),
  );
};

export const loadFilterState = (interestListId: string): FiltersState | null => {
  const storedFiltersJson = localStorage.getItem("filters-state");

  if (storedFiltersJson) {
    const filters = JSON.parse(storedFiltersJson);
    return filters[interestListId] || null;
  }

  return null;
};

export const clearFiltersState = (): void => {
  localStorage.removeItem("filters-state");
};

export const storePageNumber = (interestListId: string, page: number): void => {
  const storedPagesJson = localStorage.getItem("page-numbers") || "{}";
  const filters = JSON.parse(storedPagesJson);

  filters[interestListId] = page;

  localStorage.setItem(
    "page-numbers",
    JSON.stringify(filters),
  );
};

export const loadPageNumber = (interestListId: string): number | null => {
  const storedPagesJson = localStorage.getItem("page-numbers");

  if (storedPagesJson) {
    const pages = JSON.parse(storedPagesJson);
    return pages[interestListId] || null;
  }

  return null;
};

export const clearPageNumbers = () => {
  localStorage.removeItem("page-numbers");
};

export const toKabobCase = (value: string): string =>
  value
    .toLowerCase()
    .split(" ")
    .join("-");

export const toScreamingSnakeCase = (value: string): string => value
  // eslint-disable-next-line prefer-named-capture-group
  .replace(/([a-z\d])([A-Z])/g, "$1_$2")
  .replace(/[-\s]/g, "_")
  .toUpperCase();

export const toProperCase = (screamingSnakeCase: string) =>
  screamingSnakeCase
    .split("_") // split string into array of words
    .map(word =>
      word.charAt(0).toUpperCase() + // capitalize first letter
            word.slice(1).toLowerCase()) // make the rest of the word lower case
    .join(" "); // join words back together with spaces

export const enumToLabelMap =
<T extends Record<any, string>>(input: T): T => Object.entries(input)
  .reduce((output, [key, value]) => ({
    ...output,
    [key]: toProperCase(value),
  }), {} as T);
